import type { ChaliceStore } from '../types';

export const selectZoneFeatures = (state: ChaliceStore) =>
  state.appConfig.zoneFeatures;
export const selectLocale = (state: ChaliceStore) => state.appConfig.locale;
export const selectPageSize = (state: ChaliceStore) =>
  state.appConfig.zoneFeatures.SEARCH_PAGE_SIZE || 22;
export const selectBrand = (state: ChaliceStore) => state.appConfig.brand;
